<template>
	<el-drawer class="drawer_uploadImg" title="添加评论" :visible.sync="visible" @close='addShopStateClose' size="520px" :modal-append-to-body="false" :close-on-click-modal="false">
		<div style="padding-top:30px;">
			<div class="selectList">
				<div class="label">评论账号：</div>
				<el-select v-model="userId" placeholder="请选择" style="width:368px;">
					<el-option v-for="item in userList" :key="item._id" :label="item.basic_info.nick_name" :value="item._id">
					</el-option>
				</el-select>
			</div>
			<div class="selectList">
				<div class="label">评论内容：</div>
				<el-input v-model="pinglunContent" :rows="5" type="textarea"  style="width:368px;"></el-input>
			</div>
			<div class="submit" @click="submit">确定</div>
		</div>
	</el-drawer>
</template>
<script>
	export default {
		data() {
			return {
				
				visible: true,
				
				// 虚拟用户
				userId:'',
				userList:[],
				//
				pinglunContent:'',

			};
		},
		mounted() {
			this.getVirtualUserList();
		},
		methods: {
			addShopStateClose(){
				this.$emit("submit",{type:'close',data:{}})
			},
			submit(){
				if(this.$public.isNull(this.userId)){
					this.$message({
						message: '评论账号不能为空',
						type: 'error'
					});
					return ;
				}
				if(this.$public.isNull(this.pinglunContent)){
					this.$message({
						message: '评论内容不能为空',
						type: 'error'
					});
					return ;
				}
				let obj = {
					userId:this.userId,
					userName: this.$public.getArrItemByKey(this.userList,'_id',this.userId).basic_info.nick_name,
					userMobile:this.$public.getArrItemByKey(this.userList,'_id',this.userId).basic_info.user_mobile,
					userRemark:this.$public.getArrItemByKey(this.userList,'_id',this.userId).basic_info.remark,
					pinglunContent:this.pinglunContent,
				}
				this.$emit("submit",{type:'success',data:obj})
			},
			// 获取虚拟账号列表
			getVirtualUserList(){
				let params = {
					"shop_id": '', //门店id
					"hs_vip": -1, //花生会员：0否；1是；-1不限
					"hs_pet": -1, //花生宠物：0否；1是；-1不限
					"field": '', //搜索对象:顾客：member;宠物：pet
					"keyword": '', //关键字
					buyBackStatus:-1,
					grades:-1,
					sex: -1,  //   -1：全部、 0：女、1：男
					"class_name": '', //类别  '' 犬类； 猫类
					"pageIndex": 1,
					"pageSize": 100,
					staff_type:"5",
				}
				let loading = this.$loading()
				this.$http.post(process.env.VUE_APP_member+'/api/middleware/member/list', params).then(res => {
					loading.close();
					if (res.code == 0) {
						this.userList = res.data.data
					}
				})
			},
		}
	};
</script>

<style scoped lang="scss">
	.drawer_uploadImg {
		::v-deep .el-drawer__header {
			margin-bottom: 10px;
		}
		
		::v-deep .el-drawer__body {
			height: calc(100% - 55px);
			overflow-y: auto;
		}
		.selectList{
			padding:16px 32px;
			.label{
				display: inline-block;font-size: 14px;color:$color333;margin-right: 10px;line-height: 40px;vertical-align: top;
			}
		}
		.submit{
			background: linear-gradient(135deg, #5685FF 0%, #3569FF 100%);border-radius: 8px;line-height: 44px;margin:50px 32px 30px;text-align: center;color:#fff;font-size: 14px;cursor: pointer;
		}
	}
</style>
